"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POAAndAriaService = void 0;
var tsyringe_1 = require("tsyringe");
var arianeeHttpClient_1 = require("../../../libs/arianeeHttpClient/arianeeHttpClient");
var configurationService_1 = require("../configurationService/configurationService");
var walletService_1 = require("../walletService/walletService");
var networkConfiguration_1 = require("../../../../models/networkConfiguration");
var POAAndAriaService = /** @class */ (function () {
    function POAAndAriaService(httpClient, configurationService, walletService) {
        var _this = this;
        this.httpClient = httpClient;
        this.configurationService = configurationService;
        this.walletService = walletService;
        /**
         * @deprecated Method requestPoa is deprecated and should not be used anymore. The funding is automatic if you are using Arianee gateways.
         */
        this.requestPoa = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.warn('Method requestPoa is deprecated and should not be used anymore. The funding is automatic if you are using Arianee gateways.');
                return [2 /*return*/, true];
            });
        }); };
        this.requestAria = function () { return __awaiter(_this, void 0, void 0, function () {
            var url, e_1, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (![networkConfiguration_1.NETWORK.testnet, networkConfiguration_1.NETWORK.arianeeTestnet].includes(this.configurationService.arianeeConfiguration.networkName)) {
                            throw new Error('You are not on the testnet network');
                        }
                        url = "https://faucet.arianee.net/faucet/testnet/".concat(this.walletService.account.address, "/aria");
                        return [4 /*yield*/, this.httpClient.fetch(url)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        message = "An error occured when requesting Aria. ".concat(e_1);
                        console.warn(message);
                        throw new Error(message);
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    }
    POAAndAriaService = __decorate([
        (0, tsyringe_1.injectable)(),
        __metadata("design:paramtypes", [arianeeHttpClient_1.ArianeeHttpClient,
            configurationService_1.ConfigurationService,
            walletService_1.WalletService])
    ], POAAndAriaService);
    return POAAndAriaService;
}());
exports.POAAndAriaService = POAAndAriaService;
//# sourceMappingURL=POAAndAriaService.js.map